import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
// import { AccountService } from '../services/account.service';
// import { UserDTO } from '../DTOs/UserDTO';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { MyService } from '../my.service';
import { AuthService } from '../pages/Services/auth.service';
// import { ToastrService } from 'ngx-toastr';

import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  baseUrl = environment.apiBaseUrl;
// Refrencs  https://getbootstrap.com/docs/5.3/components/navbar/
  model: any = {};
 isLoggedIn: boolean = false;
  isAdmin: boolean = false;
  isEditor: boolean = false;
  // const isEditor = this.authService.isEditor();
// isLogin: boolean=true;

// currentUser$:Observable<UserDTO> | undefined;

// isAdmin(): boolean {
//   return this.authService.getRole() === 'admin';
// }

// isAdmin(): boolean {
//   return this.authService.isAdmin(); // استفاده درست
// }

  users: any;
  title = 'Sevayyy'
  constructor(private http: HttpClient,public acservice:MyService,private toastr: ToastrService // اضافه شد
    ,public authService :AuthService,private router:Router) { }


   ngOnInit(): void {
    // console.log(localStorage.getItem('getToken'));

    // this.authService.isLoggedIn$.subscribe(status => {
    //   this.isLoggedIn = status;

    //     if (status) {
    //     this.isAdmin = this.authService.isAdmin(); // 👈 نقش کاربر رو بعد از لاگین مشخص کن

    //   // console.log('User role:', this.authService.getRole());
    //   //  console.log('Role isEditor:', this.isEditor);
    //   const role = this.authService.getRole();
    //   // console.log('ROLE:', role);
    //    console.log('توکن بارگذاری شد، نقش:', role);
    //   this.isEditor = this.authService.isEditor();
    //   console.log('isEditor:', this.isEditor);

    // } else {
    //   this.isAdmin = false;
    //   this.isEditor = false;
    // }
    // });

     this.authService.isLoggedIn$.subscribe(status => {
    this.isLoggedIn = status;
    this.isAdmin = status ? this.authService.isAdmin() : false;
  });

  }

  login() {
    this.authService.login(this.model).subscribe({
      next: () => {
        this.isLoggedIn = true;
        this.isAdmin = this.authService.isAdmin(); // نقش رو هم بررسی کن

         this.isEditor = this.authService.isEditor();
        // const isManager = this.authService.isManager();

        this.model = {}; // پاک کردن فرم

        this.toastr.success('خوش آمدید!', 'ورود موفق');  // 🎉 پیام خوش‌آمد

        this.router.navigateByUrl('/'); // یا مسیر دلخواه
      },
      error: (err) => {
        console.error(err);
        // alert('ورود ناموفق!'); // بهتره از Toastr استفاده کنی
        this.toastr.error('نام کاربری یا رمز اشتباه است!', 'ورود ناموفق');

      }
    });
  }

  logout() {
    this.authService.logout();
  }


getusers() {
  this.http.get(`${this.baseUrl}/user`).subscribe(response=> {
this.users=response;
// console.log(response)
  },error=>{
    // console.log(error);

  });
}
}
